export const ProcessStatus = {
  ERROR: 'ERROR',
  IN_PROGRESS: 'IN_PROGRESS',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  NOT_LOADED: 'NOT_LOADED',
  NOT_STARTED: 'NOT_STARTED',
  SUCCESS: 'SUCCESS',
};

export const ReactQueryStatus = {
  ERROR: 'error',
  LOADING: 'loading',
  SUCCESS: 'success',
};

export const SESSION_TIMEOUT_ERROR = 'session timeout';
